import * as GlobalConstant from "../Constants/GlobalConstant";
import * as PathUtils from "./PathUtils";

export { ROOT_PATH, DASHBOARD_PATH } from "../Constants/GlobalConstant";

const SsoAuthenticationTokenTagName = "tkn";
const SsoAuthenticationErrorTypeTagName = "errtype";
const SsoAuthenticationErrorCodeTagName = "errcode";
const SsoAuthenticationErrorMessageTagName = "errmsg";

export const isLogoutPath = (location) => {
    if (location && location.pathname.startsWith(GlobalConstant.LOGOUT_PATH)) {
        return true;
    }
    return false;
}

export const isSsoPath = (location) => {
    if (location && location.pathname.startsWith(GlobalConstant.SSO_PATH)) {
        return true;
    }
    return false;
}

export const getSsoTokenFromLocation = (location) => {
    return PathUtils.getQueryParameterInPathString(location.search, SsoAuthenticationTokenTagName);
}

export const getSsoErrorFromLocation = (location) => {
    let errorPayload = null;

    const errorType = PathUtils.getQueryParameterInPathString(location.search, SsoAuthenticationErrorTypeTagName);
    if (errorType) {
        const errorCode = PathUtils.getQueryParameterInPathString(location.search, SsoAuthenticationErrorCodeTagName);
        const errorMessage = PathUtils.getQueryParameterInPathString(location.search, SsoAuthenticationErrorMessageTagName);
        errorPayload = {
            errorType: errorType,
            errorCode: errorCode,
            errorMessage: errorMessage
        }
    }

    return errorPayload;
}